import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";

export function Composer({ value, onChange, onSubmit, disabled }) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      className="border-t border-slate-200 p-3 flex gap-2"
    >
      <Textarea
        data-testid="assistant-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
          }
        }}
        placeholder="Ask the assistant…"
        rows={2}
        className="resize-none"
        disabled={disabled}
      />
      <Button
        type="submit"
        data-testid="assistant-send"
        disabled={disabled}
        className="bg-blue-600 hover:bg-blue-700 h-auto px-4"
      >
        <Send className="h-4 w-4" />
      </Button>
    </form>
  );
}
